import { defineMessages } from 'react-intl';

export const contactFormMessages = defineMessages<string>({
  title: {
    defaultMessage: 'CONTACT US',
    id: 'contactForm.title',
  },
  description: {
    defaultMessage:
      'Please fill out and submit the form below. We will contact you as soon as possible to provide you with the final order information including the total amount and payment method to make your purchase.',
    id: 'contactForm.description',
  },
  mandatoryFields: {
    defaultMessage: '*Mandatory fields',
    id: 'contactForm.mandatoryFields',
  },
  messagePlaceholder: {
    defaultMessage: 'Message',
    id: 'contactForm.messagePlaceholder',
  },
  submitButton: {
    defaultMessage: 'Submit',
    id: 'contactForm.submitButton',
  },
  thankYouTitle: {
    defaultMessage: 'Thank you for contacting us!',
    id: 'contactForm.thankYouTitle',
  },
  thankYouMessage: {
    defaultMessage:
      'Your message has been sent successfully. We will contact you shortly',
    id: 'contactForm.thankYouMessage',
  },
  cta: {
    defaultMessage: 'DISCOVER THE COLLECTION',
    id: 'contactForm.cta',
  },
});
